import { ArrowRight, BedDouble, Users } from "lucide-react";
import { m } from "framer-motion";
import { Link } from "react-router-dom";
import type { Apartment } from "../types";
import { staggerItem } from "./motion/tokens";
import { money } from "../utils/routes";

type ApartmentCardProps = {
  apartment: Apartment;
  /** When true, the card root becomes a stagger item for a <Stagger> grid. */
  motionItem?: boolean;
};

export function ApartmentCard({ apartment, motionItem }: ApartmentCardProps) {
  const bookable = apartment.status === "available";
  const base = bookable ? "apartment-card" : "apartment-card apartment-card--inquiry";

  const inner = (
    <>
      <div className="apartment-card__media">
        <Link to={`/apartments/${apartment.slug}`} className="apartment-card__image-link" aria-label={`View ${apartment.title}`}>
          <img src={apartment.featuredImage} alt={apartment.alt} loading="lazy" />
        </Link>
        <div className="apartment-card__meta apartment-card__meta--overlay">
          <span>{apartment.category}</span>
        </div>
      </div>
      <div className="apartment-card__body">
        <div className="apartment-card__heading">
          <h3>{apartment.title}</h3>
          {bookable && apartment.priceNight ? (
            <strong>
              {money(apartment.priceNight)}
              <span>/night</span>
            </strong>
          ) : (
            <span className="apartment-card__status">Inquiry only</span>
          )}
        </div>
        <p>{apartment.summary}</p>
        <div className="apartment-card__facts">
          {apartment.sleeps && (
            <span>
              <Users size={16} aria-hidden="true" />
              Sleeps {apartment.sleeps}
            </span>
          )}
          <span>
            <BedDouble size={16} aria-hidden="true" />
            {apartment.beds}
          </span>
        </div>
        <div className="apartment-card__footer">
          <Link className="text-link" to={`/apartments/${apartment.slug}`}>
            {apartment.listingActionLabel} <ArrowRight size={16} aria-hidden="true" />
          </Link>
        </div>
      </div>
    </>
  );

  if (motionItem) {
    return (
      <m.article className={`${base} js-reveal`} variants={staggerItem}>
        {inner}
      </m.article>
    );
  }

  return <article className={base}>{inner}</article>;
}
